<p-dialog header="Post Item Chart" (onHide)="closeDialog()" [(visible)]="displayModal" [modal]="true"
    [style]="{width: '82vw'}" [draggable]="false" [resizable]="false">
  <p-chart type="bar" [data]="data" [options]="options"></p-chart>
</p-dialog>

